if (typeof Shopify === 'undefined') {
  window.Shopify = {};
}

Shopify.theme.jsCartCounter = {
  update: () => {
    var http = new XMLHttpRequest();
    var url = '/cart.js';
    http.open('GET', url, true);

    http.onreadystatechange = function () {
      if (http.readyState == 4 && http.status == 200) {
        let data = JSON.parse(http.responseText);

        if (data.item_count > 0) {
          document.querySelector('.header__cart-counter').classList.remove('hidden');
          [...document.querySelectorAll('[data-cart-state]')].forEach(counter => counter.dataset.cartState = data.item_count);
          [...document.querySelectorAll('[ data-cart-item-count]')].forEach(counter => counter.innerText = data.item_count);
        } else {
          document.querySelector('.header__cart-counter').classList.add('hidden');
        }
      }
    };

    http.send();
  }
};
